const linkLandingPagesFR = {
    "view": {
        "table": {
            "title": "Vos pages de destination de liens",
            "column": {
                "title": "Titre",
                "description": "Description",
                "backUrl": "URL de retour",
                "created": "Créé",
                "landingPage": "Page de destination",
                "action": "Action"
            },
            "label": {
                "landingPage": "Page de destination"
            },
            "button": {
                "view": "Voir",
                "export_csv": "Exporter CSV"
            },
            "placeholder": {
                "search": "Rechercher..."
            },
            "message": {
                "linkCopied": "Lien copié dans le presse-papiers !"
            }
        },
        "modal": {
            "edit": {
                "header": "Modifier {{linkLandingPageName}} ?",
                "body": "Êtes-vous sûr de vouloir modifier cette page de destination de lien ?"
            },
            "delete": {
                "header": "Supprimer {{linkLandingPageName}} ?",
                "body": "Êtes-vous sûr de vouloir supprimer cette page de destination de lien ?"
            }
        },
        "message": {
            "success": "La page de destination de lien a été supprimée !",
            "error": "Quelque chose a mal tourné ! Veuillez actualiser la page et réessayer !",
            "llpAllowanceSpent": "Vous avez utilisé votre allocation de pages de destination de lien. Pour créer plus de pages de destination de lien, veuillez mettre à niveau votre compte ou contacter notre équipe de support.",
            "subscriptionFeatureUnavailable": "Votre plan d'abonnement actuel ne prend pas en charge cette fonctionnalité. Veuillez <1>mettre à niveau</1> votre plan d'abonnement pour bénéficier de cette fonctionnalité.",
            "subscriptionExpired": "Votre abonnement a expiré. Veuillez <1>reprendre</1> votre abonnement pour bénéficier de cette fonctionnalité.",
            "noAccess": "Vous n'avez pas accès à ce module, veuillez contacter l'équipe de support pour plus d'informations."
        }
    },
    "add": {
        "title": "Ajouter une page de destination de lien",
        "form": {
            "label": {
                "domain": "Domaine",
                "title": "Titre",
                "backUrl": "URL de retour",
                "shortDescription": "Brève description",
                "logo": "Logo",
                "backgroundImage": "Image de fond",
                "blurredBackground": "Fond flou",
                "blurred": "Flou",
                "notBlurred": "Non flou",
                "blurStrength": "Intensité du flou",
                "layout": "Disposition",
                "font": "Police",
                "socialIconPlacement": "Placement des icônes sociales",
                "socialIconColor": "Couleur des icônes sociales",
                "buttonCorners": "Coins du bouton",
                "buttonStyle": "Style du bouton",
                "colorCustomisation": "Personnalisation des couleurs",
                "premadeColors": "Couleurs prêtes à l'emploi",
                "customColors": "Couleurs personnalisées",
                "headerBackground": "Fond de l'en-tête",
                "singleColor": "Couleur unique",
                "gradient": "Dégradé",
                "bodyBackground": "Fond du corps",
                "titleColor": "Couleur du titre",
                "descriptionColor": "Couleur de la description",
                "buttonColor": "Couleur du bouton",
                "buttonTextColor": "Couleur du texte du bouton",
                "backgroundColor": "Couleur de fond"
            },
            "placeholder": {
                "domain": "Sélectionner le domaine",
                "shortDescription": "Quelques mots sur votre page de destination. 80 caractères max"
            },
            "help_text": {
                "domain": "Sélectionnez le domaine pour lequel vous souhaitez créer une page de destination de lien.",
                "logo": "Téléchargez les formats JPG ou PNG, résolution d'au moins 500x500 px",
                "backgroundImage": "Téléchargez les formats JPG ou PNG, résolution de 1000x1000 px"
            },
            "options": {
                "layout": {
                    "layoutOne": "Disposition Un",
                    "layoutTwo": "Disposition Deux"
                },
                "socialIconPlacement": {
                    "header": "En-tête",
                    "bottomOfTheBody": "Bas du corps"
                },
                "socialIconColor": {
                    "color": "Couleur",
                    "black": "Noir",
                    "white": "Blanc"
                },
                "buttonCorners": {
                    "rounded": "Arrondi",
                    "semiRounded": "Semi-arrondi",
                    "squared": "Carré"
                },
                "buttonStyle": {
                    "outlined": "Contour",
                    "filled": "Rempli"
                }
            },
            "button": {
                "submit": "Soumettre"
            },
            "validation": {
                "formInvalid": "Le formulaire ne peut pas être soumis ! Veuillez remplir tous les champs et vérifier les erreurs !",
                "storeUrlRequired": "L'URL de {{store}} est requise",
                "storeUrlValid": "Veuillez ajouter une URL valide de {{store}}."
            }
        },
        "message": {
            "success": "La page de destination de lien a été ajoutée !",
            "error": "Quelque chose a mal tourné ! Veuillez actualiser la page et réessayer !"
        },
        "modal": {
            "add": {
                "header": "Ajouter la page de destination {{title}} ?",
                "body": "Êtes-vous sûr de vouloir créer une page de destination de lien avec le titre {{title}} ?"
            }
        }
    },
    "update": {
        "title": "Mettre à jour la page de destination de lien",
        "form": {
            "label": {
                "domain": "Domaine",
                "title": "Titre",
                "backUrl": "URL de retour",
                "shortDescription": "Brève description",
                "logo": "Logo",
                "backgroundImage": "Image de fond",
                "blurredBackground": "Fond flou",
                "blurred": "Flou",
                "notBlurred": "Non flou",
                "blurStrength": "Intensité du flou",
                "layout": "Disposition",
                "font": "Police",
                "socialIconPlacement": "Placement des icônes sociales",
                "socialIconColor": "Couleur des icônes sociales",
                "buttonCorners": "Coins du bouton",
                "buttonStyle": "Style du bouton",
                "colorCustomisation": "Personnalisation des couleurs",
                "premadeColors": "Couleurs prêtes à l'emploi",
                "customColors": "Couleurs personnalisées",
                "headerBackground": "Fond de l'en-tête",
                "singleColor": "Couleur unique",
                "gradient": "Dégradé",
                "bodyBackground": "Fond du corps",
                "titleColor": "Couleur du titre",
                "descriptionColor": "Couleur de la description",
                "buttonColor": "Couleur du bouton",
                "buttonTextColor": "Couleur du texte du bouton",
                "backgroundColor": "Couleur de fond"
            },
            "placeholder": {
                "domain": "Sélectionner le domaine",
                "shortDescription": "Quelques mots sur votre page de destination. 80 caractères max"
            },
            "help_text": {
                "domain": "Sélectionnez le domaine pour lequel vous souhaitez créer une page de destination de lien.",
                "logo": "Téléchargez les formats JPG ou PNG, résolution d'au moins 500x500 px",
                "backgroundImage": "Téléchargez les formats JPG ou PNG, résolution de 1000x1000 px"
            },
            "options": {
                "layout": {
                    "layoutOne": "Disposition Un",
                    "layoutTwo": "Disposition Deux"
                },
                "socialIconPlacement": {
                    "header": "En-tête",
                    "bottomOfTheBody": "Bas du corps"
                },
                "socialIconColor": {
                    "color": "Couleur",
                    "black": "Noir",
                    "white": "Blanc"
                },
                "buttonCorners": {
                    "rounded": "Arrondi",
                    "semiRounded": "Semi-arrondi",
                    "squared": "Carré"
                },
                "buttonStyle": {
                    "outlined": "Contour",
                    "filled": "Rempli"
                },
                "platform": {
                    "instagram": "Instagram",
                    "facebook": "Facebook",
                    "twitter": "Twitter",
                    "linkedin": "LinkedIn",
                    "tiktok": "TikTok",
                    "youtube": "YouTube",
                    "other": "Autre"
                }
            },
            "button": {
                "submit": "Soumettre"
            }
        },
        "message": {
            "success": "La page de destination de lien a été mise à jour !",
            "error": "Quelque chose a mal tourné ! Veuillez actualiser la page et réessayer !"
        },
        "modal": {
            "update": {
                "header": "Mettre à jour la page de destination {{title}} ?",
                "body": "Êtes-vous sûr de vouloir mettre à jour la page de destination de lien avec le titre {{title}} ?"
            }
        }
    },
    "socialLinksRow": {
        "title": "Liens sociaux",
        "label": {
            "order": "Ordre",
            "platform": "Plateforme",
            "destinationUrl": "URL de destination"
        },
        "options": {
            "platform": {
                "instagram": "Instagram",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "linkedin": "LinkedIn",
                "tiktok": "TikTok",
                "youtube": "YouTube",
                "other": "Autre"
            }
        },
        "button": {
            "remove": "Supprimer",
            "add": "Ajouter un autre"
        }
    },
    "featuredLinksRow": {
        "title": "Liens en vedette",
        "label": {
            "order": "Ordre",
            "label": "Étiquette",
            "destinationUrl": "URL de destination"
        },
        "button": {
            "remove": "Supprimer",
            "add": "Ajouter un autre"
        }
    },
    "viewAnalytics": {
        "label": {
            "fetchingAnalytics": "Récupération des analyses pour le lien musical"
        },
        "button": {
            "last7Days": "7 derniers jours",
            "last14Days": "14 derniers jours",
            "last30Days": "30 derniers jours"
        },
        "linkLandingPageViews": {
            "title": "Vues de la page de destination de lien",
            "subtitle": "Total des vues",
            "label": {
                "views": "Vues"
            }
        },
        "socialLinkClicks": {
            "title": "Clics sur les liens sociaux",
            "subtitle": "Total des clics",
            "table": {
                "column": {
                    "platform": "Plateforme",
                    "destinationUrl": "URL de destination",
                    "clicks": "Clics",
                    "clicksPct": "Clics (%)"
                }
            }
        },
        "featuredLinkClicks": {
            "title": "Clics sur les liens en vedette",
            "subtitle": "Total des clics",
            "table": {
                "column": {
                    "label": "Étiquette",
                    "destinationUrl": "URL de destination",
                    "clicks": "Clics",
                    "clicksPct": "Clics (%)"
                }
            }
        },
        "topTerritories": {
            "title": "Territoires principaux",
            "subtitle": "Total des vues",
            "table": {
                "column": {
                    "territory": "Territoire",
                    "views": "Vues",
                    "viewsPct": "Vues (%)"
                },
                "label": {
                    "otherTerritories": "Autres territoires"
                }
            }
        },
        "topBrowsers": {
            "title": "Navigateurs principaux",
            "subtitle": "Total des vues",
            "table": {
                "column": {
                    "browser": "Navigateur",
                    "views": "Vues",
                    "viewsPct": "Vues (%)"
                }
            }
        },
        "topDeviceTypes": {
            "title": "Types d'appareils principaux",
            "table": {
                "column": {}
            }
        },
        "topOperatingSystems": {
            "title": "Systèmes d'exploitation principaux",
            "label": {
                "os": "Système d'exploitation",
                "views": "Vues"
            }
        }
    }
};

export default linkLandingPagesFR;